import { render } from "./TopNavigationMainButtons.vue?vue&type=template&id=5839c9aa"
import script from "./TopNavigationMainButtons.vue?vue&type=script&lang=js"
export * from "./TopNavigationMainButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__